export const wordFour = [
  {
    id: 1,
    text: "Century",
    response:
      "Many traditional herbs have been used as ayurvedic medicine for centuries.",
  },
  {
    id: 2,
    text: "Native",
    response:
      "Increasing pollution is endangering the plant's and animal's native habitat.",
  },
  {
    id: 3,
    text: "Navy",
    response: "Indian Navy is the world's seventh most powerful marine force.",
  },
  {
    id: 4,
    text: "Qualify",
    response:
      "Training at Military academies qualifies us to be a great soldier and a leader in general.",
  },
  {
    id: 5,
    text: "Tear",
    response: "Syria is a war-torn country.",
  },
  {
    id: 6,
    text: "Waiter",
    response:
      "How a person treats a waiter reveals a lot about their character.",
  },
  {
    id: 7,
    text: "Decorate",
    response:
      "Captain Vikram Batra has been decorated with Param Vir Chakra for his courage during the War.",
  },
  {
    id: 8,
    text: "Kiss",
    response: "Procrastination can be the kiss of death for our goals.",
  },
  {
    id: 9,
    text: "Laugh",
    response:
      "Scientific research has shown that laughing activates 43 facial muscles.",
  },
  {
    id: 10,
    text: "Liberal",
    response: "John Locke is regarded as the ‘Father of Liberalism’.",
  },
  {
    id: 11,
    text: "Painful",
    response:
      "The People of this country will never forget the painful history of oppression and slavery by Britishers.",
  },
  {
    id: 12,
    text: "Panic",
    response: "Panicking only worsens the situation.",
  },
  {
    id: 13,
    text: "Radiation",
    response:
      "UV radiation is widely used in many industrial and medical procedures.",
  },
  {
    id: 14,
    text: "Salary",
    response:
      "Government officials' salaries are determined by the active pay commission.",
  },
  {
    id: 15,
    text: "Sarcasm",
    response: "Sarcasm shows a good sense of humor.",
  },
  {
    id: 16,
    text: "Objection",
    response: "A judge has the authority to overrule the objection.",
  },
  {
    id: 17,
    text: "Harsh",
    response:
      "The state must establish harsh penalties for the abuse of National Flag.",
  },
  {
    id: 18,
    text: "Adopt",
    response:
      "We must adopt polite and passionate behavior towards others in life.",
  },
  {
    id: 19,
    text: "Agriculture",
    response:
      "West Bengal is the most agriculturally rich state followed by Andera Pradesh and Punjab.",
  },
  {
    id: 20,
    text: "Breeze",
    response:
      "Neeraj Chopra breezed to victory in javelin throw in Olympics 2020.",
  },
  {
    id: 21,
    text: "Brilliant",
    response:
      "Albert Einstein is regarded as one of the most brilliant Theoretical Physicist of all time.",
  },
  {
    id: 22,
    text: "License",
    response:
      "Selling liquor without a government-approved license is illegal in this country.",
  },
  {
    id: 23,
    text: "Radical",
    response:
      "Bhagat Singh fought for the freedom of this country using the Radical method.",
  },
  {
    id: 24,
    text: "Umpire",
    response: "Umpire's decision is final in sports and cannot be contested.",
  },
  {
    id: 25,
    text: "Wedding",
    response:
      "The wedding is considered to be a sacred union between two people.",
  },
  {
    id: 26,
    text: "Deforestation",
    response:
      "Rapid industrialization and urbanization over the period of time are one of the major factors for deforestation.",
  },
  {
    id: 27,
    text: "Grave",
    response: "Our carelessness in life can have grave consequences.",
  },
  {
    id: 28,
    text: "Ecosystem",
    response:
      "National parks provide a natural ecosystem to many different species of plants and animals.",
  },
  {
    id: 29,
    text: "Run",
    response: "Running burns highest number of calories.",
  },
  {
    id: 30,
    text: "Parliament",
    response:
      "Central Vista is a redevelopment project for the new parliament building and Raisina Hill.",
  },
  {
    id: 31,
    text: "Rage",
    response: "Rage hinders critical thinking.",
  },
  {
    id: 32,
    text: "Vagina",
    response:
      "Vaginal cancer is the rarest form of cancer, while breast cancer is the most common.",
  },
  {
    id: 33,
    text: "Verdict",
    response: "High court’s verdict can be challenged in the supreme court.",
  },
  {
    id: 34,
    text: "Electricity",
    response: "Michael Faraday is regarded as the ‘Father of Electricity.",
  },
  {
    id: 35,
    text: "Gullible",
    response:
      "Citizens are not gullible enough to believe every outrageous lie of the media.",
  },
  {
    id: 36,
    text: "Queen",
    response:
      "Jhansi Lakshmi Bai is one of the most valiant queens of all time.",
  },
  {
    id: 37,
    text: "Occupy",
    response:
      "Pakistan occupied Kashmir will one day be reinstated as an integral part of India.",
  },
  {
    id: 38,
    text: "Liquid",
    response: "Mercury is the most stable liquid Metal.",
  },
  {
    id: 39,
    text: "Literature",
    response:
      "The first Nobel Prize in Literature was awarded to Sully Prudhomme of France.",
  },
  {
    id: 40,
    text: "Television",
    response: "The first color television was launched in 1953.",
  },
  {
    id: 41,
    text: "Rare",
    response:
      "The safety and conservation of rare and endangered species must be promoted across the globe.",
  },
  {
    id: 42,
    text: "Vote",
    response:
      "Every citizen has the right to vote under Universal Adult Franchise.",
  },
  {
    id: 43,
    text: "Western",
    response: "Our modern society is greatly influenced by the Westen culture.",
  },
  {
    id: 44,
    text: "Emission",
    response:
      "The government should promote electric vehicles to prevent greenhouse gas emissions.",
  },
  {
    id: 45,
    text: "First aid",
    response:
      "First aid training should be made mandatory in schools and colleges.",
  },
  {
    id: 46,
    text: "Participate",
    response:
      "Active participation of citizens in community affairs is crucial for its overall development.",
  },
  {
    id: 47,
    text: "React",
    response: "Sunlight reacts with hydrocarbons to form Ozone.",
  },
  {
    id: 48,
    text: "Realistic",
    response: "We must have a realistic benchmark for our expectations.",
  },
  {
    id: 49,
    text: "Territory",
    response: "Chinese-held Aksai Chin is a disputed territory since 1962.",
  },
  {
    id: 50,
    text: "Windmill",
    response: "Tamil Nadu has the highest number of windmills.",
  },
  {
    id: 51,
    text: "Cheap",
    response:
      "Chinese products often use cheap materials to make to cost-effective.",
  },
  {
    id: 52,
    text: "Belief",
    response: "It is crucial to have a strong belief in our ability to win.",
  },
  {
    id: 53,
    text: "Jewelry",
    response: "Surat is famous for diamond jewelry manufacturing.",
  },
  {
    id: 54,
    text: "Quiz",
    response: "KBC is the most popular TV quiz show in India.",
  },
  {
    id: 55,
    text: "Recession",
    response: "Many countries faced economic recession during Covid outbreak.",
  },
  {
    id: 56,
    text: "No",
    response:
      "Affirming one's own worth gives one a no-nonsense outlook on life.",
  },
  {
    id: 57,
    text: "Thermometer",
    response: "Mercury is the commonly used metal in analog thermometers..",
  },
  {
    id: 58,
    text: "Vomit",
    response: "Ginger helps overcome vomit sensation.",
  },
  {
    id: 59,
    text: "Fever",
    response:
      "Demand for masks and sanitizer reached fever pitch during the pandemic.",
  },
  {
    id: 60,
    text: "Delicious",
    response:
      "Delicious bit of gossip with our old friends often gives us nostalgia.",
  },
  {
    id: 60,
    text: "Delicious",
    response:
      "Delicious bit of gossip with our old friends often gives us nostalgia.",
  },
];
